import "./FourCards.css";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Modal from "../../../Pages/ModalForm";
import Heading from "../../../utls/Heading";
const FourCards = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  return (
    <>
      <div className="container business-travel-section">
        <div className="row ms-lg-4 ms-xxl-0">
          <div className="col-md-12">
            <Heading className="text-center customheadings">
              <span>Event</span> Types We Cater To
            </Heading>
          </div>
          <div className="row px-xxl-5 mlTab ps-md-5 ps-lg-2">
            <div className="col-lg-3 col-md-6 col-12 mt-md-4 mt-3 d-flex justify-content-center">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/event1.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Corporate Meetings</h5>
                    <p className="mt-3 grotesk-headings fourcardp">
                      Even if you’re planning a small meeting of less than 10
                      members or a large gathering, our team ensures your
                      meetings deliver an effective ROI.
                    </p>
                    <div className="carouselCaption event-btn pt-lg-2 pt-xxl-0">
                      <button
                        className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter mt-lg-4 mt-xxl-0"
                        type="submit"
                        onClick={handleShow}
                      >
                        Find out more
                      </button>
                    </div>
                    <Modal show={showModal} handleClose={handleClose} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mt-md-4 mt-3  d-flex justify-content-center">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/event2.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Conferences & Summits</h5>
                    <p className="mt-3 grotesk-headings fourcardp">
                      Our expert event team delivers tailored solutions for
                      company-wide conferences, product launches, and more,
                      ensuring an impactful and memorable experience.
                    </p>
                    <div className="carouselCaption event-btn pt-lg-3 pt-xxl-0">
                      <button
                        className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter"
                        type="submit"
                        onClick={handleShow}
                      >
                        Find out more
                      </button>
                      {/* <Modal show={showModal} handleClose={handleClose} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mt-md-4 mt-3  d-flex justify-content-center">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/meetingThirdCard.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Product Launches</h5>
                    <p className="mt-3 grotesk-headings fourcardp">
                      We specialize in creating dynamic product launches that
                      captivate your audience, boost brand visibility, and drive
                      brand success.
                    </p>
                    <div className="carouselCaption  mt-lg-5 mt-xxl-0 event-btn">
                      <button
                        className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter"
                        type="submit"
                        onClick={handleShow}
                      >
                        Find out more
                      </button>
                      {/* <Modal show={showModal} handleClose={handleClose} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mt-md-4 mt-3  d-flex justify-content-center">
              <div className="BT-box shadow">
                <div className="row">
                  <div className="col-md-12 radius-image">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/images/event4.png"
                      alt=""
                      className="w-100 h-100 img-fluid"
                      loading="lazy"
                    />
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="fw-bold">Team Building Events</h5>
                    <p className="mt-3 grotesk-headings fourcardp">
                      Our innovative team-building events are designed to enable
                      collaboration, strengthen bonds, and enhance team
                      performance, ensuring lasting impact and engagement.
                    </p>
                    <div className="carouselCaption event-btn pt-lg-3 pt-xxl-0">
                      <button
                        className="btn fs4 fw-bold bg-transparent text-black text-uppercase leeter"
                        type="submit"
                        onClick={handleShow}
                      >
                        Find out more
                      </button>
                      {/* <Modal show={showModal} handleClose={handleClose} /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FourCards;
